<div class="go-paperless-terms main">
  <ds-policy-terms [partnerData]="termsPartnerData$ | async"> </ds-policy-terms>
</div>
